<template>
  <el-card id="rightSide">
    <div slot="header" class="clearfix">
      <span>{{$t('cmsg.pubRightSide.title', {title:$gf.sysParam($gf.lang(), 'title')})}}:</span>
    </div>
    <ul>
      <li>{{$t('cmsg.pubRightSide.m1')}}</li>
      <li>{{$t('cmsg.pubRightSide.m2')}}</li>
      <li>{{$t('cmsg.pubRightSide.m3')}}</li>
      <li>{{$t('cmsg.pubRightSide.m4', {title:$gf.sysParam($gf.lang(), 'title')})}}</li>
    </ul>
  </el-card>
</template>

<script>
export default {
  name: "login-righ-side",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss">
#rightSide {
  background-color: transparent;
  text-align: left;
  .el-card__header {
    background-color: transparent;
  }
  .el-card__body {
    ul {
      margin-top: 0px;
      margin-left: 0;
      padding-left: 15px;
      li {
        line-height: 28px;
      }
    }
  }
}
</style>
